module.exports = {
  de: {
    person: 'person',
    people: 'menschen',
    stone: 'stein',
    notFound: 'nicht gefunden',
    car: 'Wagen',
    cars: 'Autos'
  },
  ru: {
    person: 'персон',
    people: 'людей',
    stone: 'камней',
    notFound: 'Не найдено',
    car: 'Авто',
    cars: 'Автомобилей'
  }
};
